import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';

import { FormWrapper, TopBorderPaper } from 'components';
import { AuthResetPasswordForm } from 'forms';
import { ROUTES } from 'consts';

interface AuthResetPasswordPageProps {}

export const AuthResetPasswordPage: React.FC<AuthResetPasswordPageProps> = () => {
  const navigate = useNavigate();
  const queryParams = useLocation().search;
  const params = new URLSearchParams(queryParams);
  const token = params.get('token') as string;
  const email = params.get('email') as string;

  return (
    <Box sx={{ paddingX: 2, paddingTop: 3, paddingBottom: 8 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', padding: 3 }} />

      <Box sx={{ display: 'flex', justifyContent: 'center', minHeight: 400 }}>
        <Box sx={{ width: '100%', maxWidth: (theme) => theme.breakpoints.values.sm, position: 'relative' }}>
          <TopBorderPaper>
            <FormWrapper>
              <Typography variant="h5" sx={{ marginBottom: 1 }}>
                Reset Password
              </Typography>

              <Typography color="textSecondary" variant="body2" sx={{ lineHeight: 1.5, marginBottom: 3 }}>
                {token ? <span>Enter a new password for account: {email}</span> : <span>Missing or Invalid Token</span>}
              </Typography>

              {token ? (
                <Box marginTop={6} maxWidth={600} marginX="auto">
                  <AuthResetPasswordForm email={email} token={token} next={() => navigate(ROUTES.AUTH_LOGIN)} />
                </Box>
              ) : (
                <Link
                  variant="subtitle2"
                  onClick={() => navigate(ROUTES.AUTH_FORGOT_PASSWORD)}
                  sx={{ textDecoration: 'none', marginTop: 3, cursor: 'pointer', display: 'inline-flex' }}
                >
                  Resend Email
                </Link>
              )}
            </FormWrapper>
          </TopBorderPaper>
        </Box>
      </Box>
    </Box>
  );
};
